// Per-entity-type UI configuration for Snigdha360 (India entities).
// Keeps label + capital-structure differences in one place so admin +
// client views stay consistent.

const CONFIGS = {
  private_limited: {
    label: 'Private Limited',
    director_label: 'Director',
    directors_label: 'Directors',
    capital_kind: 'company',       // company | contribution | none
    show_shareholders: true,
    shareholder_label: 'Shareholder',
  },
  opc: {
    label: 'One Person Company',
    director_label: 'Director',
    directors_label: 'Directors',
    capital_kind: 'company',
    show_shareholders: true,
    shareholder_label: 'Shareholder',
  },
  llp: {
    label: 'LLP',
    director_label: 'Designated Partner',
    directors_label: 'Designated Partners',
    capital_kind: 'contribution',
    show_shareholders: false,      // partners hold contribution, no separate shareholder concept
    shareholder_label: 'Partner',
  },
  partnership: {
    label: 'Partnership',
    director_label: 'Partner',
    directors_label: 'Partners',
    capital_kind: 'contribution',
    show_shareholders: false,
    shareholder_label: 'Partner',
  },
  proprietorship: {
    label: 'Proprietorship',
    director_label: 'Proprietor',
    directors_label: 'Proprietor',
    capital_kind: 'none',
    show_shareholders: false,
    shareholder_label: 'Owner',
  },
  section_8: {
    label: 'Section 8 Company',
    director_label: 'Director',
    directors_label: 'Directors',
    capital_kind: 'company',
    show_shareholders: true,
    shareholder_label: 'Member',
  },
  non_profit: {
    label: 'Non-Profit',
    director_label: 'Director',
    directors_label: 'Directors',
    capital_kind: 'company',
    show_shareholders: true,
    shareholder_label: 'Member',
  },
  society_registered: {
    label: 'Registered Society',
    director_label: 'Office Bearer',
    directors_label: 'Office Bearers',
    capital_kind: 'company',
    show_shareholders: true,
    shareholder_label: 'Member',
  },
  llc: {
    label: 'LLC',
    director_label: 'Director',
    directors_label: 'Directors',
    capital_kind: 'company',
    show_shareholders: true,
    shareholder_label: 'Shareholder',
  },
  corporation: {
    label: 'Corporation',
    director_label: 'Director',
    directors_label: 'Directors',
    capital_kind: 'company',
    show_shareholders: true,
    shareholder_label: 'Shareholder',
  },
};

const DEFAULT_CONFIG = CONFIGS.private_limited;

export function entityConfig(entityType) {
  if (!entityType) return DEFAULT_CONFIG;
  const cfg = CONFIGS[String(entityType).toLowerCase()] || DEFAULT_CONFIG;
  // Only LLP/Partnership actually share profit & loss between partners.
  return { ...cfg, has_profit_share: cfg.capital_kind === 'contribution' };
}
